import { sendRawRequest, sendRequest } from "@api/clients/axios";

type UpdatePushNotificationToken = {
  token: string;
};

type UpdatePushNotificationTokenResponse = {
  id: number;
  token: string;
};

export async function updatePushNotificationToken(
  updatePushNotificationToken: UpdatePushNotificationToken
) {
  // Throws on failure (instead of swallowing) so callers can surface the
  // registration problem. Logout-time clearing stays best-effort below.
  const res = await sendRequest<UpdatePushNotificationToken, UpdatePushNotificationTokenResponse>(
    "post",
    "notifications/set-notification-token",
    updatePushNotificationToken
  );
  if (res.status === 201) {
    return res.data;
  }
  throw new Error(`Unexpected status ${res.status} while saving push notification token`);
}

/**
 * Unregisters a push token using an explicit auth token, so it can run during
 * logout after the local session has already been cleared.
 */
export async function clearPushNotificationToken(authToken: string) {
  return sendRawRequest<{ token: string }, unknown>(
    "post",
    "notifications/set-notification-token",
    { token: "" },
    { headers: { Authorization: authToken } }
  ).catch((error) => {
    console.error("Error clearing push notification token:", error);
  });
}
